"use strict";
import Detection from "../../widgets/detection.js"
import './presentation.less';

App.Pages.Presentation = class Presentation extends PF.Page
{

    static get options()
    {
        return {
            rights: {
                user: true
            },
            panel: false,
            path: '/presentation',
            nameRu: 'Презентация',
        };
    }

    static get template()
    {
        //language=HTML
        return /*html*/`
            <div class="page navbar-fixed">
				<div class="page-content ptr-content no-overflow" pf="pageContent">
                    <div class="block"></div>

					<div class="row">
                        <div class="col-50">
                            <div class="card" pf="chartAll">
                                <h4>За всё время</h4> 
                                <div class="row">
                                    <div pf="topAllEmotions" class="col-33 pie"></div>
                                    <div pf="topAllGenders" class="col-33 pie"></div>
                                    <div pf="topAllAge" class="col-33 pie"></div>
                                </div>
                                <div class="row">
                                    <div class="col-10"></div>
                                    <div class="col-30">
                                        <h4>Всего посетителей:</h4>                                        
                                        <div class="clock" style="padding-left:16px;padding-top:8px;">
                                            <div class="part">
                                                <div class="digit2" pf="countAllPerson">
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                    
                                    <div class="col-60">
                                        <h4>Среднее время просмотра экрана</h4>
                                        <div class="clock" style="padding-left:16px;padding-top:8px;">
                                            <div class="part">
                                                <div class="digit2">
                                                    <div class="digit" pf="m1All">0</div>
                                                    <div class="digit" pf="m2All">0</div>
                                                </div>
                                                <div>минут</div>
                                            </div>
                                            <div class="colon">:</div>
                                            <div class="part">
                                                <div class="digit2">
                                                    <div class="digit" pf="s1All">0</div>
                                                    <div class="digit" pf="s2All">0</div>
                                                    <div class="digit" style="text-align: center;">.</div>
                                                    <div class="digit" pf="ms1All">0</div>
                                                    <div class="digit" pf="ms2All">0</div>
                                                    <div class="digit" pf="ms3All">0</div>
                                                </div>
                                                <div>секунд</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-50">
                            <div class="card" pf="chartHours">
                                <h4>За последний час</h4>
                                <div class="row">
                                    <div pf="topHoursEmotions" class="col-33 pie"></div>
                                    <div pf="topHoursGenders" class="col-33 pie"></div>
                                    <div pf="topHoursAge" class="col-33 pie"></div>
                                </div>
                                <div class="row">
                                    <div class="col-20"></div>
                                    <div class="col-60">
                                        <h4>Среднее время просмотра экрана</h4>
                                        <div class="clock" style="padding-left:16px;padding-top:8px;">
                                            <div class="part">
                                                <div class="digit2">
                                                    <div class="digit" pf="m1">0</div>
                                                    <div class="digit" pf="m2">0</div>
                                                </div>
                                                <div>минут</div>
                                            </div>
                                            <div class="colon">:</div>
                                            <div class="part">
                                                <div class="digit2">
                                                    <div class="digit" pf="s1">0</div>
                                                    <div class="digit" pf="s2">0</div>
                                                    <div class="digit" style="text-align: center;">.</div>
                                                    <div class="digit" pf="ms1">0</div>
                                                    <div class="digit" pf="ms2">0</div>
                                                    <div class="digit" pf="ms3">0</div>
                                                </div>
                                                <div>секунд</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-20"></div>
                                </div>
                            </div>
                        </div>
                    </div>

					<div class="row">
                        <div class="col-50">
                            <div class="card">
                                <div class="list" pf="list"></div>
                            </div>
                        </div>
                        <div class="col-50">
                            <div class="card" pf='liveCameraStream'></div>
                        </div>
                    </div>

				</div>
			</div>
		`;
    }

    init()
    {
        super.init();

        app.panelDisplay(0);
        this.dom.pageContent.css('height', '100%');

        this.listDetections = new PF.List({
            dom: {
                element: this.dom.list,
                // scrollTarget: this.dom.pageContent,
            },
            html: {
                header: {},
                //language=HTML
                wrapper: `
                    <div class="pf-list-wrapper" pf="wrapper">
                        <ul pf="ul" style="display: flex; flex-wrap: wrap;">
                        </ul>
                    </div>
                `,
                preloaderContent: ``,
            },
            searchable: false,
            modelsConfig: {
                represent: 'detection/ViewAllPres',
            },
            before: true,
            itemClass: DetectionLocal,
        });

        this.countUpdateDetections = 1;
        this.lastUpdateDetections = DateTime.local();

        // запрос новых детекций, раз в 5 сек
        Util.interval(5000, () => this.listDetections.models.update());

        // получили новую детекцию
        this.listDetections.on('addOne', (e) =>
        {
            this.lastUpdateDetections = DateTime.local();
            this.countUpdateDetections++;
        }, true);

        // проверка на подвисания детекций
        Util.interval(10000, () => {
            let currentDt = DateTime.local();
            currentDt = currentDt.ts - this.lastUpdateDetections.ts;
            console.log(currentDt, this.lastUpdateDetections.ts);
            if (currentDt > 90000) { // если обновлений не было больше 1,5 минут
                this.lastUpdateDetections = DateTime.local();
                this.countUpdateDetections = 0;
            }
        });

        // фикс подвисания детекций
        Util.interval(20000, () =>
        {
            console.log(this.countUpdateDetections);
            if (this.countUpdateDetections == 0) 
            {
                console.log('reload');
                this.listDetections.models.reload();
                this.countUpdateDetections = 1;
                // location.reload();
            }
        });

        // Util.sleep(3600000).then(() => {  
        //     console.log('reload');
        //     location.reload();
        // });

        // charts
        this.charts();
        this.dom.chartAll.bindHtml();
        this.dom.countAllPerson.bindHtml();
        this.dom.m1All.bindText();
        this.dom.m2All.bindText();
        this.dom.s1All.bindText();
        this.dom.s2All.bindText();
        this.dom.ms1All.bindText();
        this.dom.ms2All.bindText();
        this.dom.ms3All.bindText();

        this.dom.chartHours.bindHtml();
        this.dom.m1.bindText();
        this.dom.m2.bindText();
        this.dom.s1.bindText();
        this.dom.s2.bindText();
        this.dom.ms1.bindText();
        this.dom.ms2.bindText();
        this.dom.ms3.bindText();

        this.dom.liveCameraStream.bindHtml();
        Util.sleep(1000).then(() => this.stream());
    }

    //---------------
    // chart bloc

    charts()
    {
        this.optionPie = {
            chart: {
                height: 350,
                type: 'pie',
            },
            tooltip: {
                pointFormat: '<b>{point.percentage:.1f} %</b>'
            },
            accessibility: {
                point: {
                    valueSuffix: '%'
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false,
                    },
                    showInLegend: true,
                    center: ["50%", 100]
                }
            },
            legend: {
                itemStyle: {
                    fontSize: '9px',
                },
                align: 'center',
                // enabled: true,
                // layout: 'vertical',
                // verticalAlign: 'bottom',
            },
        };
        this.chartsAll()
        this.chartsHours()

        Util.interval(300000, () => this.chartsHours());
        Util.interval(600000, () => this.chartsAll());
    }

    chartsAll()
    {
        this.dom.topAllEmotions.empty();
        this.dom.countAllPerson.empty();
        app.request('/demo/presentation/', [], (response) =>
        {
            let responseAll = response;
            if (responseAll.status != 'FAIL')
            {
                let emotions = new Highcharts.chart(this.dom.topAllEmotions.node, {
                    title: {
                        useHTML: true,
                        //language=HTML
                        text: `<h4>Эмоции</h4>`,
                        align: 'left',
                    },
                    series: [responseAll.data.topEmotions.series],
                    ...this.optionPie
                });
                let gen = new Highcharts.chart(this.dom.topAllGenders.node, {
                    title: {
                        useHTML: true,
                        //language=HTML
                        text: `<h4>Пол</h4>`,
                        align: 'left',
                    },
                    series: [responseAll.data.topGender.series],
                    ...this.optionPie
                });
                let age = new Highcharts.chart(this.dom.topAllAge.node, {
                    title: {
                        useHTML: true,
                        //language=HTML
                        text: `<h4>Возраст</h4>`,
                        align: 'left',
                    },
                    series: [responseAll.data.topAge.series],
                    ...this.optionPie
                });
                //
                this.displayChartTimeAll(responseAll.data.avgViewTimeByStella);
                //
                this.dom.countAllPerson.html = ``;
                let num = responseAll.data.d_and_p.p.all;
                let sNumber = num.toString();
                let sum = '';
                for (var i = 0, len = sNumber.length; i < len; i += 1)
                {
                    sum += `<div class="digit">${sNumber.charAt(i)}</div>`;
                }
                this.dom.countAllPerson.html = sum;
            }
            else
            {

            }
        });
    } // chartsAll

    displayChartTimeAll(timeStr)
    {
        let m1 = 0, m2 = 0, s1 = 0, s2 = 0, ms1 = 0, ms2 = 0, ms3 = 0;
        if (timeStr !== null)
        {
            let dur = Duration.fromISOTime(timeStr);
            let m = dur.minutes;
            m1 = m < 10 ? 0 : Math.floor(m / 10);
            m2 = m % 10;
            let s = dur.seconds;
            s1 = s < 10 ? 0 : Math.floor(s / 10);
            s2 = s % 10;
            let ms = dur.milliseconds;
            if (ms > 100)
            {
                ms1 = Math.floor(ms / 100);
                ms = ms - ms1 * 100;
                ms2 = Math.floor(ms / 10);
                ms3 = ms % 10;
            } else
            {
                ms1 = 0;
                ms2 = ms < 10 ? 0 : Math.floor(ms / 10);
                ms3 = ms % 10;
            }
        }
        this.dom.m1All.text = m1;
        this.dom.m2All.text = m2;
        this.dom.s1All.text = s1;
        this.dom.s2All.text = s2;
        this.dom.ms1All.text = ms1;
        this.dom.ms2All.text = ms2;
        this.dom.ms3All.text = ms3;
    }

    chartsHours()
    {
        this.dom.topHoursEmotions.empty();
        app.request('/demo/presentation/chart-hours', [], (response) =>
        {
            let responseHours = response;
            if (responseHours.status != 'FAIL')
            {
                this.emotions = new Highcharts.chart(this.dom.topHoursEmotions.node, {
                    title: {
                        useHTML: true,
                        //language=HTML
                        text: `<h4>Эмоции</h4>`,
                        align: 'left',
                    },
                    series: [responseHours.data.avgEmotionByStella.emotions.series],
                    ...this.optionPie
                });
                let gen = new Highcharts.chart(this.dom.topHoursGenders.node, {
                    title: {
                        useHTML: true,
                        //language=HTML
                        text: `<h4>Пол</h4>`,
                        align: 'left',
                    },
                    series: [responseHours.data.topGender.series],
                    ...this.optionPie
                });
                let age = new Highcharts.chart(this.dom.topHoursAge.node, {
                    title: {
                        useHTML: true,
                        //language=HTML
                        text: `<h4>Возраст</h4>`,
                        align: 'left',
                    },
                    series: [responseHours.data.topAge.series],
                    ...this.optionPie
                });

                this.displayChartTime(responseHours.data.avgViewTimeByStella);
            }
            else
            {

            }
        });
    } // chartsHours

    displayChartTime(timeStr)
    {
        let m1 = 0, m2 = 0, s1 = 0, s2 = 0, ms1 = 0, ms2 = 0, ms3 = 0;
        if (timeStr !== null)
        {
            let dur = Duration.fromISOTime(timeStr);
            let m = dur.minutes;
            m1 = m < 10 ? 0 : Math.floor(m / 10);
            m2 = m % 10;
            let s = dur.seconds;
            s1 = s < 10 ? 0 : Math.floor(s / 10);
            s2 = s % 10;
            let ms = dur.milliseconds;
            if (ms > 100)
            {
                ms1 = Math.floor(ms / 100);
                ms = ms - ms1 * 100;
                ms2 = Math.floor(ms / 10);
                ms3 = ms % 10;
            } else
            {
                ms1 = 0;
                ms2 = ms < 10 ? 0 : Math.floor(ms / 10);
                ms3 = ms % 10;
            }
        }
        this.dom.m1.text = m1;
        this.dom.m2.text = m2;
        this.dom.s1.text = s1;
        this.dom.s2.text = s2;
        this.dom.ms1.text = ms1;
        this.dom.ms2.text = ms2;
        this.dom.ms3.text = ms3;
    }

    // End chart bloc
    //---------------

    stream()
    {
        let browser = Util.browser();

        try
        {
            app.request('/demo/presentation/stream', [], (response) =>
            {
                this.listStream = response;
                if (this.listStream.status != 'FAIL')
                {
                    this.dom.liveCameraStream.bindHtml();
                    let cam = this.listStream.data[0];
                    let url = new URL(cam.stream);
                    let newUrl = url; //url.protocol + '//' + url.hostname + url.pathname;
                    this.dom.liveCameraStream.html = `<img class="stream-img" src="${newUrl}"></img>`;

                    // this.liveCameraStream = new PF.List({
                    //     dom: {
                    //         element: this.dom.liveCameraStream,
                    //     },
                    //     html: {
                    //         header: {},
                    //         //language=HTML
                    //         wrapper: /* html */`
                    //             <div class="pf-list-wrapper" pf="wrapper">
                    //                 <ul pf="ul"></ul>
                    //             </div>`,
                    //         preloaderContent: ``,
                    //     },
                    //     searchable: false,
                    //     modelsConfig: {
                    //         raw: this.listStream.data
                    //     },
                    //     itemClass: Stream,
                    // });
                }
                else
                {
                    console.log(response);
                    Util.sleep(200000).then(() => this.stream());
                }
            });
        } catch (error)
        {
            console.log(error);
            Util.sleep(200000).then(() => this.stream());
        }
    } // stream

}; // class Presentation

class Stream extends PF.List.Item
{
    get renderer()
    {
        //language=HTML
        return `
            <div pf="item item-content">
                <div class="item-inner">
                    <div class="item-title">
                        <img class="stream-img" src="@{model.src}"></img>
                    </div>
                    <div class="item-after detection-after"></div>
                    <div class="item-subtitle"></div>
                </div>
            </div>
		`;
    }

    onRender()
    {
        super.onRender();
        let src = '';
        if (Util.browser() == 'Firefox')
        {
            src = this.model.stream;
        } else
        {
            src = this.url(this.model.stream);
        }
        src = this.url(this.model.stream);

        if (src !== false)
        {
            this.model.src = src;
            this.model.type = 'stream';
        } else
        {
            this.model.type = 'snaping';
            this.i = 0;

            // переделать ↓
            // fetch(`/camera/snap?id=${this.model.id}&i=${this.i}`, {
            //     method: "GET",
            // }).then((response) =>
            // {
            //     if (response.status == 200)
            //     {
            //         this.snaping();
            //     }
            // });
            // setInterval(() =>
            // {
            // }, 5000);
        }

    } // onRender

    snaping()
    {
        // переделать ↓
        // this.model.src = `/camera/snap?id=${this.model.id}&i=${this.i}`;
        // this.i++;
        // Util.sleep(8000).then(() => { this.snaping(); });
    } // snaping

    url(stream)
    {
        if (stream)
        {
            let url = new URL(stream);
            if (url.protocol != 'rtsp:')
            {
                let newUrl = url.protocol + '//' + url.hostname;
                try
                {
                    let xhr = new XMLHttpRequest();
                    xhr.withCredentials = true;
                    // xhr.responseType = 'blob';
                    xhr.open('GET', newUrl, true);
                    xhr.setRequestHeader("Authorization", "Basic " + btoa(`${url.username}:${url.password}`));
                    xhr.setRequestHeader("Access-Control-Allow-Origin", '*');
                    // xhr.setRequestHeader("Access-Control-Allow-Origin", location.protocol + '//' + location.hostname);
                    // xhr.setRequestHeader("Access-Control-Allow-Origin", url.protocol + '//' + url.hostname);
                    xhr.setRequestHeader("Access-Control-Allow-Headers", '*');
                    xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
                    xhr.send();
                } catch (error)
                {
                    return false;
                }
                return newUrl + url.pathname;
            } else
            {
                return false;
                // return url.href;
            }
        } else
        {
            return false;
        }
    } // url
} // class Stream

//-----------------------------
// Detection ↓
class DetectionLocal extends Detection
{
    get renderer()
    {
        //language=HTML
        return `
    		<div class="item item-content" style="padding-left: 0; width: 295px;" pf="link">
                <div class="item-inner">
                    <div class="item-title" style="display: flex;">
                        <div class="p-img" pf="img">
                            @{model.img}
                        </div>
                        <div>
                            <span title="Время">@{model.startMscT}</span>
                            <span pf="firstDetection"></span> <br/>
                            <span pf="emotion" title="Преобладающая эмоция">@{model.emotion.name}</span> 
                            <span pf="emotionPercent" title="Среднее значение преобладающей эмоции">@{model.emotionPercent}</span><br/>
                            <span title="пол">Пол: @{model.person.gender.name}</span><br/>
                            <span title="возраст">Возраст: @{model.person.age}</span><br/>
                        </div>
                        <div><span pf="hasScreenViewText"></span><span pf="processText"></span></div>
                    </div>
                </div>
    		</div>
    	`;
    }

    onRender()
    {
        super.onRender();
        if (this.model.similarity == 1)
        {
            this.dom.firstDetection.bindHtml();
            this.dom.firstDetection.html += `<br>Первая детекция`;
        }
    }

    linkPerson() {
        this.dom.linkPerson.on("click", () =>
        {
            app.pageParams.setData('id', this.model.person_id);
            app.pageParams.setData('similarity', this.model.similarity);
            app.pageParams.setData('return', 'detections');
            app.popupRect = null;
            this.popup.close();
            app.router.navigate('/pres-stat');
        });
    }
}
